<template>


  <div>

    <div class="boxContent" id="oneStepCart" v-if="!paymentCreated">
      <div id="cartTop">
        <h1 class="title" v-if="cartItems.length">
                        <span class="CallLineTxt shpng_head contact-info">
                            Express secure checkout
                        </span>
        </h1>
        <p style="text-align: center; margin: 1rem 0;" v-if="!cartItems.length">Your shopping cart is currently
          empty.</p>
      </div>
      <div class="inner2 ship_frm_wrap row" v-if="cartItems.length">
        <div class="ship_block col-md-4" v-if="isMobile == true">
          <div class="tdCheckoutHeaderG">
            <span class="txtCheckoutHeader">1. Order Summary </span>
          </div>
          <div id="cartCol">
            <table class="table-cart">
              <tbody v-for="product in products">
              <tr class="pro_rw">
                <td class="tdcartTitle2">
                  <img :src="product.product_image"
                       :alt="product.info['M_TITLE']" class="shipImage"
                       :title="product.info['M_TITLE']">
                </td>
                <td>
                  <span class="ship_pro_label" v-html="product.info['M_TITLE']"></span>
                </td>
              </tr>
              <tr class="pro_rw">
                <td class="tdcartTitle2">
                  <label>Regular Price</label>
                </td>
                <td>
                  <span class="linethrough">${{ product.price }}</span>
                </td>
              </tr>
              <tr class="pro_rw red">
                <td class="tdcartTitle2">
                  <label><span>Sale Price</span></label>
                </td>
                <td>
                  <span>${{ product.sale_price }}</span>
                </td>
              </tr>
              <tr class="pro_rw form">
                <td class="tdcartTitle2">
                  <label>Quantity</label>
                </td>
                <td>
                  <input name="updateCartQuanValue" type="number" :value="product.quantity"
                         @input="updateProduct($event, product)" min="0" class="textbox">
                </td>
              </tr>
              </tbody>
              <tbody>
              <tr class="no_border red">
                <td class="no_border "><label><span>Discount</span></label>
                </td>
                <td>
                  <span>- ${{ discountResult }}</span>
                </td>
              </tr>
              <tr class="no_border red">
                <td class="no_border ">
                  <label><span>Valid For</span></label>
                </td>
                <td>
                  <span><span id="countdownToMidnight">{{ timeToMidnight }}</span></span>
                </td>
              </tr>
              <tr class="lyt_blu_bg no_border ">
                <td>
                  <label>Sub Total</label>
                </td>
                <td>
                  ${{ subTotal }}
                </td>
              </tr>
              <tr class="no_border ">
                <td>
                  <label>Shipping</label>
                </td>
                <td>
                  ${{ shippingPrice }}
                </td>
              </tr>
              <tr class="no_border ">
                <td>
                  <label>Tax </label>
                </td>
                <td>
                  {{ taxPrice }}
                </td>
              </tr>
              <tr class="drk_blu_bg no_border ">
                <td>
                  <label>Order Total</label>
                </td>
                <td>
                  ${{ productsOrderTotal }}
                </td>
              </tr>
              <tr class="no_border ">
                <td class=" ">
                </td>
                <td>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>
        <div class="ship_block col-md-4">
          <div id="addressCol">
            <div class="tdCheckoutHeader">
              <span class="txtCheckoutHeader">{{ isMobile == true ? 2 : 1 }}. Billing Address</span>
            </div>
            <div class="form-row">
              <div class="form">
                <span class="cartTxtMain">*First Name:</span>
                <input name="firstName" type="text" class="textbox"
                       :class="invalidFields.firstName ? 'error' : ''"
                       id="firstName" v-model="formData.first_name" @blur="validateFieldOnFocus">
                <span class="help-block form-error"
                      v-if="invalidFields.firstName">First Name is a required field.</span>
              </div>
              <div class="form">
                <span class="cartTxtMain">*Last Name:</span>
                <input name="lastName" type="text" class="textbox" id="lastName"
                       v-model="formData.last_name" :class="invalidFields.lastName ? 'error' : ''"
                       @blur="validateFieldOnFocus">
                <span class="help-block form-error"
                      v-if="invalidFields.lastName">Last Name is a required field.</span>
              </div>
              <div class="form">
                <span class="cartTxtMain">*Email</span>
                <input name="email" type="text" class="textbox validate"
                       :class="invalidFields.email ? 'error' : ''" id="email"
                       v-model="formData.email" @blur="validateFieldOnFocus">
                <span class="help-block form-error"
                      v-if="invalidFields.email">Email Address is a required field</span>
              </div>
              <div class="form">
                <span class="cartTxtMain">*Telephone</span>
                <input name="phone" type="text" class="textbox " id="phone"
                       v-model="formData.phone" :class="invalidFields.phone ? 'error' : ''"
                       @blur="validateFieldOnFocus" @keydown="acceptNumber()">
                <span class="help-block form-error"
                      v-if="invalidFields.phone">Phone Number is a required field.</span>
              </div>
            </div>
            <div class="form">
              <span class="cartTxtMain">*Address 1:</span>
              <input name="add_1" type="text" class="textbox " id="add_1"
                     v-model="formData.add_1" :class="invalidFields.add_1 ? 'error' : ''"
                     @blur="validateFieldOnFocus">
              <span class="help-block form-error"
                    v-if="invalidFields.add_1">Address is a required field.</span>
            </div>
            <div class="form"><span class="cartTxtMain">Address 2:</span>
              <input name="add_2" type="text" class="textbox" id="add_2" v-model="formData.add_2">
            </div>
            <div class="form"><span class="cartTxtMain">*City:</span>
              <input name="town" type="text" class="textbox " id="town" @blur="validateFieldOnFocus"
                     v-model="formData.town" :class="invalidFields.town ? 'error' : ''">
              <span class="help-block form-error"
                    v-if="invalidFields.town">City is a required field.</span>
            </div>
            <div class="form-row">
              <div class="form"><span class="cartTxtMain">*State:</span>
                <select name="county" id="county" class="selectbox " v-model="formData.county">
                  <option :value="county" v-for="county in this.states">{{ county }}</option>
                </select>
                <span class="help-block form-error"
                      v-if="invalidFields.county">State is a required field.</span>
              </div>
              <div class="form"><span class="cartTxtMain">*Zip:</span>

                <input name="postcode" type="text" class="textbox " id="postcode"
                       v-model="formData.postcode" :class="invalidFields.postcode ? 'error' : ''"
                       @blur="validateFieldOnFocus">
                <span class="help-block form-error"
                      v-if="invalidFields.postcode">Zip is a required field.</span>
              </div>
            </div>
            <div class="form"><span class="cartTxtMain">*Country:</span>
              <select name="country" id="country" class="selectbox" v-model="formData.country">
                <option :value="id" v-for="(country, id) in this.countries">{{ country }}</option>
              </select>
            </div>
            <!--
            <div class="form">
              <input type="checkbox" name="createAccount" value="1" id="createAccount"
                     v-model.number="formData.needUserCreate">
              <label for="createAccount">Create Account</label>
            </div>

            <div class="form" v-if="formData.needUserCreate">
              <div class="accountSection has-success"><span
                  class="cartTxtMain">*Choose Password:</span>

                <input name="pass_confirmation" type="password" class="textbox valid"
                       @blur="validateFieldOnFocus"
                       id="pass_confirmation" v-model="formData.pass_confirmation"
                       :class="invalidFields.pass_confirmation ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.pass_confirmation">Password is a required field.</span>
              </div>
            </div>
            <div class="form" v-if="formData.needUserCreate">
              <div class="accountSection"><span
                  class="cartTxtMain">*Confirm Password:</span>

                <input name="pass" type="password" class="textbox " id="pass"
                       @blur="validateFieldOnFocus" data-match="pass_confirmation"
                       v-model="formData.pass" :class="invalidFields.pass ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.pass">Passwords must match.</span>
              </div>
            </div>
            -->

            <div class="form">
              <input type="checkbox" name="shipToDiffAddress" value="1" id="shipToDiffAddress"
                     v-model="formData.shipToDifferent">
              <label for="shipToDiffAddress">Ship to different address</label>
            </div>
            <div class="form">
              <div style="display: none;" class="deliverySection tdCheckoutHeader">
                <div style="display: none;" class="deliverySection"><span class="txtCheckoutHeader">&nbsp;&nbsp;&nbsp;Shipping Information</span>
                </div>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span class="cartTxtMain">*First Name:</span>

                <input name="delInf[firstName]" type="text" class="textbox " id="delfirstName"
                       @blur="validateFieldOnFocus"
                       v-model="formData.delInf.first_name"
                       :class="invalidFields.delfirstName ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.delfirstName">Delivery First Name is a required field.</span>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span class="cartTxtMain">*Last Name:</span>

                <input name="delInf[lastName]" type="text" class="textbox " id="dellastName"
                       @blur="validateFieldOnFocus"
                       v-model="formData.delInf.last_name"
                       :class="invalidFields.dellastName ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.dellastName">Delivery Last Name is a required field.</span>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span
                  class="cartTxtMain">*Address:</span>

                <input name="delInf[add_1]" type="text" class="textbox " id="deladd_1"
                       @blur="validateFieldOnFocus"
                       v-model="formData.delInf.add_1" :class="invalidFields.deladd_1 ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.deladd_1">Delivery Address is a required field.</span>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span
                  class="cartTxtMain">Address 2:</span>
                <input name="delInf[add_2]" type="text" class="textbox " id="deladd_2"
                       v-model="formData.delInf.add_2">
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span
                  class="cartTxtMain">*City: </span>

                <input name="delInf[town]" type="text" class="textbox " id="deltown"
                       @blur="validateFieldOnFocus"
                       v-model="formData.delInf.town" :class="invalidFields.deltown ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.deltown">Delivery City is a required field.</span>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span
                  class="cartTxtMain">*State:</span>

                <select name="delInf[county]" id="delcounty" class="selectbox "
                        v-model="formData.delInf.county">
                  <option :value="county" v-for="county in this.states">{{ county }}</option>
                </select>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span
                  class="cartTxtMain">*ZIP Code:</span>

                <input name="delInf[postcode]" type="text" class="textbox " id="delpostcode"
                       @blur="validateFieldOnFocus"
                       v-model="formData.delInf.postcode"
                       :class="invalidFields.delpostcode ? 'error' : ''">
                <span class="help-block form-error"
                      v-if="invalidFields.delpostcode">Delivery Zip Code is a required field.</span>
              </div>
            </div>
            <div class="form" v-if="formData.shipToDifferent">
              <div class="deliverySection"><span
                  class="cartTxtMain">*Country:</span>

                <select name="delInf[country]" id="delcountry" class="selectbox"
                        v-model="formData.delInf.country">
                  <option :value="id" v-for="(country, id) in this.countries">{{ country }}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
        <div class="ship_block col-md-4">
          <div id="shippingPaymentCol">
            <div class="tdCheckoutHeader">
              <span class="txtCheckoutHeader">{{ isMobile == true ? 3 : 2 }}. Shipping Options</span>
            </div>
            <div class="form">
              <div class="cartTxtMain">
                <table class="table-shipping-options">
                  <tbody>
                  <tr>
                    <td><input name="shipping" type="radio" value="1" checked="checked"
                               v-model="formData.shipping"></td>
                    <td>Priority Shipping ($19.95) <br> 2-3 Business Days</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- <div class="shiping_note">*Includes a pre-paid return label for returning you old car
              computer and activating your warranty.
            </div> -->
            <div id="selectGateway">
              <div class="tdCheckoutHeaderB"><span class="txtCheckoutHeader">{{ isMobile == true ? 4 : 3 }}. Payment Options</span>
              </div>

              <br>

              <div class="form">
                <div class="">
                  <input name="gateway" type="radio" id="Authorize_AIM" value="2"
                         class="gateways" v-model="formData.paymentType" @change="clearPaymentErrors">
                  <label for="Authorize_AIM"><span class="cartTxtMain">Credit Card</span></label>

                  <img
                    style="width: 100%; max-width: 280px"
                    :src="paymentMethodsLogo"
                    alt="payment_logo"
                    class="payment_logo"
                  />
                </div>
              </div>


              <div class="form" v-if="formData.paymentType == 2">
                <div class=" authoriseOnly">
                  <label for="cardNumber">
                    <span class="cartTxtMain">Card Number:</span>
                  </label>

                  <input type="text" @change="cardValidation" name="cardNumber" id="cardNumber" value="" size="19"
                         v-model="formData.aim.card" :class="invalidFields.cardNumber ? 'error' : ''"
                         maxlength="19" class="textbox " @blur="validateFieldOnFocus">
                  <span class="help-block form-error"
                        v-if="invalidFields.cardNumber">Credit Card Number is a required field.</span>
                </div>
              </div>
              <div class=" authoriseOnly form-row" v-if="formData.paymentType == 2">
                <div class="form">
                  <label for="expirationMonth">
                    <span class="cartTxtMain">Expiration Month:</span>
                  </label>

                  <select name="expirationMonth" id="expirationMonth" class="textbox "
                          @change="validateFieldOnFocus"
                          v-model="formData.aim.month"
                          :class="invalidFields.expirationMonth ? 'error' : ''">
                    <option value="">Month</option>
                    <option :value="id + 1" v-for="(name, id) in orderedMonths">{{ name }}</option>
                  </select>
                  <span class="help-block form-error"
                        v-if="invalidFields.expirationMonth">Expiration Month is a required field.</span>
                </div>
                <div class="form">
                  <label for="expirationMonth">
                    <span class="cartTxtMain">Expiration Year:</span>
                  </label>

                  <select name="expirationYear" id="expirationYear" class="textbox "
                          @change="validateFieldOnFocus"
                          v-model="formData.aim.year"
                          :class="invalidFields.expirationYear ? 'error' : ''">
                    <option value="">Year</option>
                    <option :value="id" v-for="(year, id) in this.years">{{ year }}</option>
                  </select>
                  <span class="help-block form-error"
                        v-if="invalidFields.expirationYear">Expiration Year is a required field.</span>
                </div>
              </div>

              <br>

              <div class="form">
                <div v-if="isPayPalActive()">
                  <input name="gateway" type="radio" id="PayPal" value="1" class="gateways"
                         v-model="formData.paymentType" @change="clearPaymentErrors">
                  <label for="PayPal"><span class="cartTxtMain">PayPal</span>
                  </label>

                  <img :src="this.payPalLogo" alt="payment_logo"
                       class="payment_logo">
                </div>
              </div>


              <br>


<!--
              <div class="form venmoRadio">
                <div v-if="isPayPalActive()">
                  <input name="gateway" type="radio" id="Venmo" value="3" class="gateways"
                         v-model="formData.paymentType" @change="clearPaymentErrors">
                  <label for="PayPal"><span class="cartTxtMain">Venmo</span>
                  </label>
                  <img src="/img/images/venmo-logo.png" alt="payment_logo"
                       class="payment_logo">
                </div>
              </div>

              <br>
-->



              <div class="form gPayRadio" v-if="isMobile == true && !isIphoneOrIpad">
                <div v-if="isGooglePayActive()">
                  <input name="gateway" type="radio" id="gPay" value="4" class="gateways"
                         v-model="formData.paymentType" @change="clearPaymentErrors">
                  <label for="gPay"><span class="cartTxtMain">Google Pay</span>
                  </label>

                  <img :src="this.gpayLogo" alt="gpayLogo"
                       class="payment_logo">
                </div>
              </div>

              <br><br>

              <div class="form applePayRadio" v-if="isMobile == true && isIphoneOrIpad">
                <div v-if="isGooglePayActive()">
                  <input name="gateway" type="radio" id="applePayInput" value="5" class="gateways"
                         v-model="formData.paymentType" @change="clearPaymentErrors">
                  <label for="applePayInput"><span class="cartTxtMain">Apple Pay</span>
                  </label>

                </div>
              </div>



              <br><br>


            </div>
          </div>
        </div>
        <div class="ship_block col" v-if="isMobile == false">
          <div class="tdCheckoutHeaderG">
            <span class="txtCheckoutHeader">4. Order Summary </span>
          </div>
          <div id="cartCol">
            <table class="table-cart">
              <tbody v-for="product in products">
              <tr class="pro_rw">
                <td class="tdcartTitle2">
                  <img :src="product.product_image"
                       :alt="product.info['M_TITLE']" class="shipImage"
                       :title="product.info['M_TITLE']">
                </td>
                <td>
                  <span class="ship_pro_label" v-html="product.info['M_TITLE']"></span>
                </td>
              </tr>
              <tr class="pro_rw">
                <td class="tdcartTitle2">
                  <label>Regular Price</label>
                </td>
                <td>
                  <span class="linethrough">${{ product.price }}</span>
                </td>
              </tr>
              <tr class="pro_rw red">
                <td class="tdcartTitle2">
                  <label><span>Sale Price</span></label>
                </td>
                <td>
                  <span>${{ product.sale_price }}</span>
                </td>
              </tr>
              <tr class="pro_rw form">
                <td class="tdcartTitle2">
                  <label>Quantity</label>
                </td>
                <td>
                  <input name="updateCartQuanValue" type="number" :value="product.quantity"
                         @input="updateProduct($event, product)" min="0" class="textbox">
                </td>
              </tr>
              </tbody>
              <tbody>
              <tr class="no_border red">
                <td class="no_border "><label><span>Discount</span></label>
                </td>
                <td>
                  <span>- ${{ discountResult }}</span>
                </td>
              </tr>
              <tr class="no_border red">
                <td class="no_border ">
                  <label><span>Valid For</span></label>
                </td>
                <td>
                  <span><span id="countdownToMidnight">{{ timeToMidnight }}</span></span>
                </td>
              </tr>
              <tr class="lyt_blu_bg no_border ">
                <td>
                  <label>Sub Total</label>
                </td>
                <td>
                  ${{ subTotal }}
                </td>
              </tr>
              <tr class="no_border ">
                <td>
                  <label>Shipping</label>
                </td>
                <td>
                  ${{ shippingPrice }}
                </td>
              </tr>
              <tr class="no_border ">
                <td>
                  <label>Tax </label>
                </td>
                <td>
                  {{ taxPrice }}
                </td>
              </tr>
              <tr class="drk_blu_bg no_border ">
                <td>
                  <label>Order Total</label>
                </td>
                <td>
                  ${{ productsOrderTotal }}
                </td>
              </tr>
              <tr class="no_border ">
                <td class=" ">
                </td>
                <td>
                </td>
              </tr>
              </tbody>
            </table>


          </div>
          <div class="ship_block col" style="flex: 1;max-width: 100%;padding-right: 0px;padding-left: 0px;">
            <div :class="showVenmoButton == false && showGPayButton == false && showAPayButton == false ? 'place_btn' : 'hidden'"><a href="#" class="placeOrder"
                                      title="Place My Order" @click="validAllFields($event)">Place Order</a>
                                    <div v-if="processing === true" class="processing-message">Processing...</div>
                                    <div v-if="processing === true" class="processing-spinner"></div>
            </div>

            <div :class="formData.paymentType == 3 && showVenmoButton == true  ? '' : 'hidden'">
              <div id="paypal-button"></div>
            </div>

            <div :class="showGPayButton ? '' : 'hidden'">
              <div id="gPayContainer"></div>
            </div>


            <div :class="showAPayButton ? '' : 'hidden'">
              <button type="button" id="applePay"></button>
            </div>


            <div>
              <h4>100% Car Match + Satisfaction Guarantee</h4>
              <p>We guarantee that your car computer will be pre-programmed to match your exact vehicle
                specifications.</p>
              <p>All our car computers are simple plug-and-play. No need to visit a dealer.</p>
              <h4>NO additional programming will be required.</h4>
            </div>
          </div>
        </div>
        <div class="ship_block col" v-if="isMobile == true">
          <div :class="showVenmoButton == false && showGPayButton == false && showAPayButton == false  ? 'place_btn' : 'hidden'"><a href="#" class="placeOrder"
                                    title="Place My Order" @click="validAllFields($event)">Place Order</a>
                                    <div v-if="processing === true" class="processing-message">Processing...</div>
                                    <div v-if="processing === true" class="processing-spinner"></div>
          </div>

          <div :class="formData.paymentType == 3 && showVenmoButton == true ? '' : 'hidden'">
            <div id="paypal-button"></div>
          </div>

            <div :class="formData.paymentType == 4 && showGPayButton == true ? '' : 'hidden'">
              <div id="gPayContainer"></div>
            </div>

            <div :class="formData.paymentType == 5 && showAPayButton == true ? '' : 'hidden'">
              <button type="button" id="applePay"></button>
            </div>




          <div>
            <h4>100% Car Match + Satisfaction Guarantee</h4>
            <p>We guarantee that your car computer will be pre-programmed to match your exact vehicle
              specifications.</p>
            <p>All our car computers are simple plug-and-play. No need to visit a dealer.</p>
            <h4>NO additional programming will be required.</h4>
          </div>
        </div>
        <div id="extraInput"></div>
      </div>
    </div>
    <div v-if="paymentCreated">
      <div style="text-align: center">
        <p align="left" v-if="paymentCreated.payment_gateway == 2 && paymentCreated.error">Please fill out the form below to proceed with your payment:</p>
        <table width="400" border="0" align="center" cellpadding="3" cellspacing="2" class="tblListCheckout">
          <tbody>
          <tr align="left">
            <td align="left" valign="middle" class="tdCheckoutHeaderB" v-if="paymentCreated.payment_gateway == 2 && paymentCreated.error"><span class="txtCheckoutTitle">Pay by Credit Card</span>
            <td align="left" valign="middle" class="tdCheckoutHeaderB" v-if="paymentCreated.payment_gateway == 1"><span class="txtCheckoutTitle">Pay by PayPal</span>
            </td>
          </tr>

          <tr align="left" v-if="paymentCreated.payment_gateway == 2 && paymentCreated.error">
            <td>
              <p class="error">210: This transaction has been declined</p>
              <table width="98%" border="0" align="left" cellpadding="0" cellspacing="2">
                <tbody>
                <tr align="left">
                  <td><strong>First Name:</strong></td>
                  <td><input type="text" name="firstName" v-model="formData.first_name"></td>
                </tr>

                <tr align="left">
                  <td><strong>Last Name:</strong></td>
                  <td><input type="text" name="lastName" v-model="formData.last_name"></td>
                </tr>

                <tr align="left">
                  <td><strong>Card Number:</strong></td>
                  <td><input type="text" name="cardNumber" v-model="formData.aim.card" maxlength="16"></td>
                </tr>

                <tr align="left">
                  <td><strong>Expires:</strong></td>
                  <td><input type="text" name="expirationMonth" v-model="formData.aim.month" size="2" maxlength="2"
                             class="textbox"> /
                    <input type="text" name="expirationYear" v-model="formData.aim.year" size="2" maxlength="2"
                           class="textbox">

                    <input type="hidden" name="emailAddress" value="">
                  </td>
                </tr>

                <tr align="left">
                  <td valign="top"><strong>Address:</strong></td>
                  <td><input type="text" name="addr1" v-model="formData.add_1" class="textbox"
                             style="margin-bottom: 2px;"><br>
                    <input type="text" name="addr2" v-model="formData.add_2" class="textbox">
                  </td>
                </tr>

                <tr align="left">
                  <td><strong>City:</strong></td>
                  <td><input type="text" name="city" v-model="formData.town" class="textbox"></td>
                </tr>
                <tr align="left">
                  <td><strong>State:</strong></td>
                  <td><input type="text" name="state" v-model="formData.county" class="textbox"></td>
                </tr>
                <tr align="left">
                  <td><strong>Zip Code:</strong></td>
                  <td><input type="text" name="postalCode" v-model="formData.postcode" class="textbox"></td>
                </tr>
                <tr align="left">
                  <td><strong>Country:</strong>
                  </td>
                  <td colspan="3">
                    <select name="country" class="textbox">
                      <option value="AF">Afghanistan</option>

                      <option value="AL">Albania</option>

                      <option value="DZ">Algeria</option>

                      <option value="AS">American Samoa</option>

                      <option value="AD">Andorra</option>

                      <option value="AO">Angola</option>

                      <option value="AI">Anguilla</option>

                      <option value="AQ">Antarctica</option>

                      <option value="AG">Antigua and Barbuda</option>

                      <option value="AR">Argentina</option>

                      <option value="AM">Armenia</option>

                      <option value="AW">Aruba</option>

                      <option value="AU">Australia</option>

                      <option value="AT">Austria</option>

                      <option value="AZ">Azerbaijan</option>

                      <option value="BS">Bahamas</option>

                      <option value="BH">Bahrain</option>

                      <option value="BD">Bangladesh</option>

                      <option value="BB">Barbados</option>

                      <option value="BY">Belarus</option>

                      <option value="BE">Belgium</option>

                      <option value="BZ">Belize</option>

                      <option value="BJ">Benin</option>

                      <option value="BM">Bermuda</option>

                      <option value="BT">Bhutan</option>

                      <option value="BO">Bolivia</option>

                      <option value="BA">Bosnia and Herzegovi…</option>

                      <option value="BW">Botswana</option>

                      <option value="BV">Bouvet Island</option>

                      <option value="BR">Brazil</option>

                      <option value="IO">British Indian Ocean…</option>

                      <option value="BN">Brunei Darussalam</option>

                      <option value="BG">Bulgaria</option>

                      <option value="BF">Burkina Faso</option>

                      <option value="BI">Burundi</option>

                      <option value="KH">Cambodia</option>

                      <option value="CM">Cameroon</option>

                      <option value="CA">Canada</option>

                      <option value="CV">Cape Verde</option>

                      <option value="KY">Cayman Islands</option>

                      <option value="CF">Central African Repu…</option>

                      <option value="TD">Chad</option>

                      <option value="CL">Chile</option>

                      <option value="CN">China</option>

                      <option value="CX">Christmas Island</option>

                      <option value="CC">Cocos (Keeling) Isla…</option>

                      <option value="CO">Colombia</option>

                      <option value="KM">Comoros</option>

                      <option value="CG">Congo</option>

                      <option value="CD">Congo, the Democrati…</option>

                      <option value="CK">Cook Islands</option>

                      <option value="CR">Costa Rica</option>

                      <option value="CI">Cote D'Ivoire</option>

                      <option value="HR">Croatia</option>

                      <option value="CU">Cuba</option>

                      <option value="CY">Cyprus</option>

                      <option value="CZ">Czech Republic</option>

                      <option value="DK">Denmark</option>

                      <option value="DJ">Djibouti</option>

                      <option value="DM">Dominica</option>

                      <option value="DO">Dominican Republic</option>

                      <option value="EC">Ecuador</option>

                      <option value="EG">Egypt</option>

                      <option value="SV">El Salvador</option>

                      <option value="GQ">Equatorial Guinea</option>

                      <option value="ER">Eritrea</option>

                      <option value="EE">Estonia</option>

                      <option value="ET">Ethiopia</option>

                      <option value="FK">Falkland Islands (Ma…</option>

                      <option value="FO">Faroe Islands</option>

                      <option value="FJ">Fiji</option>

                      <option value="FI">Finland</option>

                      <option value="FR">France</option>

                      <option value="GF">French Guiana</option>

                      <option value="PF">French Polynesia</option>

                      <option value="TF">French Southern Terr…</option>

                      <option value="GA">Gabon</option>

                      <option value="GM">Gambia</option>

                      <option value="GE">Georgia</option>

                      <option value="DE">Germany</option>

                      <option value="GH">Ghana</option>

                      <option value="GI">Gibraltar</option>

                      <option value="GR">Greece</option>

                      <option value="GL">Greenland</option>

                      <option value="GD">Grenada</option>

                      <option value="GP">Guadeloupe</option>

                      <option value="GU">Guam</option>

                      <option value="GT">Guatemala</option>

                      <option value="GN">Guinea</option>

                      <option value="GW">Guinea-Bissau</option>

                      <option value="GY">Guyana</option>

                      <option value="HT">Haiti</option>

                      <option value="HM">Heard Island and Mcd…</option>

                      <option value="VA">Holy See (Vatican Ci…</option>

                      <option value="HN">Honduras</option>

                      <option value="HK">Hong Kong</option>

                      <option value="HU">Hungary</option>

                      <option value="IS">Iceland</option>

                      <option value="IN">India</option>

                      <option value="ID">Indonesia</option>

                      <option value="IR">Iran, Islamic Republ…</option>

                      <option value="IQ">Iraq</option>

                      <option value="IE">Ireland</option>

                      <option value="IL">Israel</option>

                      <option value="IT">Italy</option>

                      <option value="JM">Jamaica</option>

                      <option value="JP">Japan</option>

                      <option value="JO">Jordan</option>

                      <option value="KZ">Kazakhstan</option>

                      <option value="KE">Kenya</option>

                      <option value="KI">Kiribati</option>

                      <option value="KP">Korea, Democratic Pe…</option>

                      <option value="KR">Korea, Republic of</option>

                      <option value="KW">Kuwait</option>

                      <option value="KG">Kyrgyzstan</option>

                      <option value="LA">Lao People's Democra…</option>

                      <option value="LV">Latvia</option>

                      <option value="LB">Lebanon</option>

                      <option value="LS">Lesotho</option>

                      <option value="LR">Liberia</option>

                      <option value="LY">Libyan Arab Jamahiri…</option>

                      <option value="LI">Liechtenstein</option>

                      <option value="LT">Lithuania</option>

                      <option value="LU">Luxembourg</option>

                      <option value="MO">Macao</option>

                      <option value="MK">Macedonia, the Forme…</option>

                      <option value="MG">Madagascar</option>

                      <option value="MW">Malawi</option>

                      <option value="MY">Malaysia</option>

                      <option value="MV">Maldives</option>

                      <option value="ML">Mali</option>

                      <option value="MT">Malta</option>

                      <option value="MH">Marshall Islands</option>

                      <option value="MQ">Martinique</option>

                      <option value="MR">Mauritania</option>

                      <option value="MU">Mauritius</option>

                      <option value="YT">Mayotte</option>

                      <option value="MX">Mexico</option>

                      <option value="FM">Micronesia, Federate…</option>

                      <option value="MD">Moldova, Republic of</option>

                      <option value="MC">Monaco</option>

                      <option value="MN">Mongolia</option>

                      <option value="MS">Montserrat</option>

                      <option value="MA">Morocco</option>

                      <option value="MZ">Mozambique</option>

                      <option value="MM">Myanmar</option>

                      <option value="NA">Namibia</option>

                      <option value="NR">Nauru</option>

                      <option value="NP">Nepal</option>

                      <option value="NL">Netherlands</option>

                      <option value="AN">Netherlands Antilles</option>

                      <option value="NC">New Caledonia</option>

                      <option value="NZ">New Zealand</option>

                      <option value="NI">Nicaragua</option>

                      <option value="NE">Niger</option>

                      <option value="NG">Nigeria</option>

                      <option value="NU">Niue</option>

                      <option value="NF">Norfolk Island</option>

                      <option value="MP">Northern Mariana Isl…</option>

                      <option value="NO">Norway</option>

                      <option value="OM">Oman</option>

                      <option value="PK">Pakistan</option>

                      <option value="PW">Palau</option>

                      <option value="PS">Palestinian Territor…</option>

                      <option value="PA">Panama</option>

                      <option value="PG">Papua New Guinea</option>

                      <option value="PY">Paraguay</option>

                      <option value="PE">Peru</option>

                      <option value="PH">Philippines</option>

                      <option value="PN">Pitcairn</option>

                      <option value="PL">Poland</option>

                      <option value="PT">Portugal</option>

                      <option value="PR">Puerto Rico</option>

                      <option value="QA">Qatar</option>

                      <option value="RE">Reunion</option>

                      <option value="RO">Romania</option>

                      <option value="RU">Russian Federation</option>

                      <option value="RW">Rwanda</option>

                      <option value="SH">Saint Helena</option>

                      <option value="KN">Saint Kitts and Nevi…</option>

                      <option value="LC">Saint Lucia</option>

                      <option value="PM">Saint Pierre and Miq…</option>

                      <option value="VC">Saint Vincent and th…</option>

                      <option value="WS">Samoa</option>

                      <option value="SM">San Marino</option>

                      <option value="ST">Sao Tome and Princip…</option>

                      <option value="SA">Saudi Arabia</option>

                      <option value="SN">Senegal</option>

                      <option value="CS">Serbia and Montenegr…</option>

                      <option value="SC">Seychelles</option>

                      <option value="SL">Sierra Leone</option>

                      <option value="SG">Singapore</option>

                      <option value="SK">Slovakia</option>

                      <option value="SI">Slovenia</option>

                      <option value="SB">Solomon Islands</option>

                      <option value="SO">Somalia</option>

                      <option value="ZA">South Africa</option>

                      <option value="GS">South Georgia and th…</option>

                      <option value="ES">Spain</option>

                      <option value="LK">Sri Lanka</option>

                      <option value="SD">Sudan</option>

                      <option value="SR">Suriname</option>

                      <option value="SJ">Svalbard and Jan May…</option>

                      <option value="SZ">Swaziland</option>

                      <option value="SE">Sweden</option>

                      <option value="CH">Switzerland</option>

                      <option value="SY">Syrian Arab Republic</option>

                      <option value="TW">Taiwan, Province of …</option>

                      <option value="TJ">Tajikistan</option>

                      <option value="TZ">Tanzania, United Rep…</option>

                      <option value="TH">Thailand</option>

                      <option value="TL">Timor-Leste</option>

                      <option value="TG">Togo</option>

                      <option value="TK">Tokelau</option>

                      <option value="TO">Tonga</option>

                      <option value="TT">Trinidad and Tobago</option>

                      <option value="TN">Tunisia</option>

                      <option value="TR">Turkey</option>

                      <option value="TM">Turkmenistan</option>

                      <option value="TC">Turks and Caicos Isl…</option>

                      <option value="TV">Tuvalu</option>

                      <option value="UG">Uganda</option>

                      <option value="UA">Ukraine</option>

                      <option value="AE">United Arab Emirates</option>

                      <option value="GB">United Kingdom</option>

                      <option value="US" selected="selected">United States</option>

                      <option value="UM">United States Minor …</option>

                      <option value="UY">Uruguay</option>

                      <option value="UZ">Uzbekistan</option>

                      <option value="VU">Vanuatu</option>

                      <option value="VE">Venezuela</option>

                      <option value="VN">Viet Nam</option>

                      <option value="VG">Virgin Islands, Brit…</option>

                      <option value="VI">Virgin Islands, U.s.</option>

                      <option value="WF">Wallis and Futuna</option>

                      <option value="EH">Western Sahara</option>

                      <option value="YE">Yemen</option>

                      <option value="ZM">Zambia</option>

                      <option value="ZW">Zimbabwe</option>

                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
        <br style="clear: both;">
        <div align="center">
          <table border="0" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
              <td v-if="paymentCreated.payment_gateway == 1 && paymentCreated.url && showVenmoButton == false">
                <div class="place_btn"><a :href="paymentCreated.url" class="placeOrder"
                                          title="Checkout">Pay Now</a></div>
              </td>
              <td v-if="paymentCreated.payment_gateway == 2 && paymentCreated.error && showVenmoButton == false">
                <div class="place_btn"><a href="#" class="placeOrder"
                                          title="Checkout" @click="validAllFields($event)">Pay Now</a></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert);


export default {
  props: ['paymentMethodsLogo', 'payPalLogo', 'paypalToggle', 'gpayLogo', 'googlePayToggle'],
  created() {
    setInterval(() => {
      let now = new Date()
      let hrs = 23 - now.getHours()
      let mins = 59 - now.getMinutes()
      let secs = 59 - now.getSeconds()
      let str = ''
      this.timeToMidnight = str = '' + hrs + ' hrs ' + mins + ' mins ' + secs + ' secs '
    }, 1000)

    this.cartItems = JSON.parse(localStorage.getItem('items')) || [];
    //console.log(this.cartItems)
    let idsList = []
    this.cartItems.forEach(item => {
      idsList.push(item.id)
    })
    this.formData.paymentType = 0 //localStorage.getItem('payment_gateway') || 2;

    let storageFormData = JSON.parse(localStorage.getItem('formData')) || null;

    if( storageFormData != null ) this.formData = storageFormData;

    axios.post('/api/products', {ids: idsList})
        .then(res => {
          this.products = res.data || []
          this.products.forEach(product => {
            this.cartItems.forEach(item => {
              if (item.id == product.id) {
                product.quantity = item.quantity
              }
            })
          })
        })
        .catch(err => {
          this.products = null
        })
  },
  computed: {
    changeAddress() {
      const { email, phone, first_name, last_name, county, town, add_1, add_2, postcode, delInf } = this.formData
      return {
        email, phone, first_name, last_name, county, town, add_1, add_2, postcode, delInf
      }
    },
    orderedMonths: function () {
      return _.orderBy(this.months)
    },
    taxPrice: function () {
      if (!this.products) return 0
      if (this.taxFetched !== 0) {
        return '$' + this.taxFetched.toFixed(2)
      } else if (!this.taxStates[this.formData.county]) {
        return 'n/a'
      } else {
        let price = parseInt(this.subTotal) * this.taxStates[this.formData.county]
        return '$' + price.toFixed(2)
      }
    },
    productsOrderTotal: function () {
      if (!this.products) return 0
      let price = 0
      this.products.forEach(product => {
        price += product.sale_price * product.quantity
      })
      let shippingPrice = parseFloat(this.shippingPrice)
      price += shippingPrice;
      if (this.taxFetched !== 0) {
        price += this.taxFetched
      } else if (!this.taxStates[this.formData.county]) {
        price += 0;
      } else {
        let tax_price = parseInt(this.subTotal) * this.taxStates[this.formData.county]
        price += tax_price
      }

      var checkoutData = JSON.parse(localStorage.getItem('checkoutData')) || {};
      checkoutData.total = price.toFixed(2);
      localStorage.setItem('checkoutData', JSON.stringify(checkoutData));

      localStorage.setItem('cartTotal', price.toFixed(2) );
      return price.toFixed(2)
    },
    discountResult: function () {
      if (!this.products) return 0
      let discount = 0
      this.products.forEach(product => {
        discount += (product.price * product.quantity) - (product.sale_price * product.quantity)
      })
      return discount.toFixed(2)
    },
    shippingPrice: function () {
      if (!this.products) return 0
      let shipPrice = 0
      this.products.forEach(product => {
        let priceByItem = 0
        if (product.shipping_rate && product.shipping_rate.price_per_item) {
          priceByItem = parseFloat(product.shipping_rate.price_per_item) || 0
        } else {
          if (product.ship_by_item){
            priceByItem = parseFloat(product.ship_by_item.split(';')[0]) || 0
          }

        }
        shipPrice += priceByItem
      })
      var checkoutData = JSON.parse(localStorage.getItem('checkoutData')) || {};
      checkoutData.shipping_price = shipPrice.toFixed(2);
      localStorage.setItem('checkoutData', JSON.stringify(checkoutData));
      localStorage.setItem('shipping_price', shipPrice.toFixed(2) );
      return shipPrice.toFixed(2)
    },
    subTotal: function () {
      if (!this.products) return 0
      let subTotal = 0
      this.products.forEach(product => {
        subTotal += product.sale_price * product.quantity
      })
      return subTotal.toFixed(2)
    },
    isMobile: function () {
      let check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    isIphoneOrIpad: function () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

  },
  watch: {

    'formData.paymentType': {
        handler(val) {
          this.showVenmoButton = false;
          this.showGPayButton = false;
          this.showAPayButton = false;
        },
        deep: true
    },
    products: {
      handler(val) {
        val.forEach(item => {
          this.cartItems.forEach(cart => {
            if (cart.id == item.id) {
              cart.quantity = item.quantity
            }
          })
        })
      },
      deep: true
    },
    cartItems: {
      handler(val) {
        localStorage.setItem('items', JSON.stringify(val))
      },
      deep: true
    },
    changeAddress: {
      handler(val) {
        this.showGPayButton = false;
        this.checkAddressFields()
      },
      deep: true
    }
  },
  data() {
    return {
      processing: false,
      failed: false,
      paymentCreated: false,
      invalidFields: {},
      taxFetched: 0,
      showGPayButton: false,
      showAPayButton: false,
      formData: {
        first_name: '',
        last_name: '',
        country: 226,
        phone: '',
        add_1: '',
        add_2: '',
        town: '',
        email: '',
        postcode: '',
        county: 'Alabama',
        //pass_confirmation: '',
        //pass: '',
        shipToDifferent: 0,
        needUserCreate: 0,
        shipping: 1,
        paymentType: 0,
        delInf: {
          first_name: '',
          last_name: '',
          add_1: '',
          add_2: '',
          town: '',
          county: 'Alabama',
          country: 226,
          postcode: ''
        },
        aim: {
          month: '',
          year: '',
          card: ''
        }
      },
      states: [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "Armed Forces Africa",
        "Armed Forces Americas",
        "Armed Forces Canada",
        "Armed Forces Europe",
        "Armed Forces Middle East",
        "Armed Forces Pacific",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Federated States Of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Islands",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
        "Puerto Rico"
      ],
      countries: {
        226: "United States",
        173: "Puerto Rico"
      },
      months: {
        1: '01- January',
        2: '02- February',
        3: '03- March',
        4: '04- April',
        5: '05- May',
        6: '06- June',
        7: '07- July',
        8: '08- August',
        9: '09- September',
        10: '10- October',
        11: '11- November',
        12: '12- December'
      },
      years: {
        21: '2021',
        22: '2022',
        23: '2023',
        24: '2024',
        25: '2025',
        26: '2026',
        27: '2027',
        28: '2028',
        29: '2029',
        30: '2030',
        31: '2031',
        32: '2032',
        33: '2033',
        34: '2034',
        35: '2035',
        36: '2036',
        37: '2037',
        38: '2038',
        39: '2039',
        40: '2040',
        41: '2041',
        42: '2042',
        43: '2043',
        44: '2044',
        45: '2045',
        46: '2046',
        47: '2047',
        48: '2048',
        49: '2049',
        50: '2050',
        51: '2051',
        52: '2052',
      },
      products: null,
      cartItems: null,
      timeToMidnight: '',
      taxStates: {
        'North Carolina': 0.077487
      },
      notRequiredInputs: [
        'add_2',
        'delInf|shipToDifferent',
        'needUserCreate',
        'paymentType',
        'shipToDifferent',
        'pass_confirmation|needUserCreate',
        'pass|needUserCreate',
        'products'
      ],
      showVenmoButton: false,
    }
  },
  methods: {
    isPayPalActive() {
      return !(this.paypalToggle === 'OFF')
    },
    isGooglePayActive(){
      return !(this.googlePayToggle === 'OFF')
    },

    checkAddressFields() {
      const contactFields = [
        'email',
        'phone',
      ]
      const addressFields = [
        'first_name',
        'last_name',
        'county', // Full name
        'town',
        'add_1',
        'postcode',
      ]
      const data = (this.formData.shipToDifferent !== 0) ? this.formData.delInf : this.formData
      for (let i = 0; i < contactFields.length; i ++) {
        const key = contactFields[i]
        if (this.formData[key].length == 0) return // contact information is required
      }
      for (let i = 0; i < addressFields.length; i ++) {
        const key = addressFields[i]
        if (data[key].length == 0) return // address information is required
      }
      const postData = {
        zip: data.postcode,
        country: 'US',
        state: data.county,
        city: data.town,
        address1: data.add_1,
        address2: data.add_2,
        customer: this.formData.email,
        total: this.subTotal,
      }
      axios.post('/api/tax-calculate', postData)
      .then(response => {
        if (response.status === 200 && response.data.success) {
          this.taxFetched = response.data.tax
        }
      }).catch(_ => { })
    },

    async validAllFields(e, data = null, masterKey = null) {

      e.preventDefault()

      if( this.processing === true ) {
        return false;
      }

      if( data == null ) {
        this.invalidFields = {};
      }

      if (!data) {
        data = this.formData
      }

      /**
       * there's two way to ignore some fields
       * 1-st way is just put field which should be ignored
       * 2-nd way is put field|next_field:value which contains a field with the value parameter
       * like pass_confirmation will be checked if needUserCreate won't be 0
       * @type {string[]}
       */
      let notRequired = this.notRequiredInputs;

      for (let key in data) {
        let needCheck = true
        notRequired.forEach(field => {
          let fieldArr = field.split('|')
          let valueForField = ''
          let nextField = ''
          if (fieldArr.length > 1) {
            valueForField = fieldArr[1].split(':')[1]
            nextField = fieldArr[1].split(':')[0]
          }

          if (fieldArr.length === 1 && key == fieldArr[0]) {
            needCheck = false
          }

          // if this item contains next field and it's false we need to ignore field
          if (fieldArr.length === 2 && key == fieldArr[0] && !this.formData[nextField]) {
            needCheck = false
          }

          if (valueForField && key == fieldArr[0] && this.formData[nextField] !== valueForField) {
            needCheck = false
          }
        })
        if (!needCheck) continue;

        if (typeof data[key] == 'object') {
          return this.validAllFields(e, data[key], key)
        }

        if (masterKey) {
          if (!this.formData[masterKey][key]) {
            this.$set(this.invalidFields, this.mappingModelToErrors(masterKey + '.' + key), true)
          }
        } else {
          if (!this.formData[key]) {
            this.$set(this.invalidFields, this.mappingModelToErrors(key), true)
          }
          //if (key === 'pass' && this.formData['pass_confirmation'] !== this.formData[key]) {
          //  this.$set(this.invalidFields, this.mappingModelToErrors(key), true)
          //}
        }
      }

      let canCreateOrder = true

      for (let key in this.invalidFields) {

        if(this.formData.paymentType != 2) {
          if( key == 'cardNumber' ) continue;
          if( key == 'expirationMonth' ) continue;
          if( key == 'expirationYear' ) continue;
        }
        if (this.invalidFields[key]) {
            location.hash = "#addressCol";
            this.$message({
              message: 'Please Fill All Required Fields',
              type: 'error'
            });
            return;
        }
      }


      if(this.formData.paymentType == 0) {
        this.$message({
          message: 'Please select Payment Type',
          type: 'error'
        });
        location.hash = "#selectGateway";
        return;
      }

      return this.orderCreate()
    },
    orderCreate() {


      if(this.formData.paymentType == 5) {

        let checkoutData = {
          "first_name":this.formData.first_name,
          "last_name":this.formData.last_name,
          "country":this.formData.country,
          "phone":this.formData.phone,
          "add_1":this.formData.add_1,
          "add_2":this.formData.add_2,
          "town":this.formData.town,
          "email":this.formData.email,
          "postcode":this.formData.postcode,
          "county":this.formData.county,
          "total": this.productsOrderTotal,
          "shipping_price": this.shippingPrice,
        };
        localStorage.setItem('checkoutData', JSON.stringify(checkoutData));

        this.showAPayButton = true;

        return;

      } else if(this.formData.paymentType == 4) {

        let checkoutData = {
          "first_name":this.formData.first_name,
          "last_name":this.formData.last_name,
          "country":this.formData.country,
          "phone":this.formData.phone,
          "add_1":this.formData.add_1,
          "add_2":this.formData.add_2,
          "town":this.formData.town,
          "email":this.formData.email,
          "postcode":this.formData.postcode,
          "county":this.formData.county,
          "total": this.productsOrderTotal,
          "shipping_price": this.shippingPrice,
        };
        localStorage.setItem('checkoutData', JSON.stringify(checkoutData));

        this.showGPayButton = true;

        return;

      } else if(this.formData.paymentType == 3) {

        let checkoutData = {
          "first_name":this.formData.first_name,
          "last_name":this.formData.last_name,
          "country":this.formData.country,
          "phone":this.formData.phone,
          "add_1":this.formData.add_1,
          "add_2":this.formData.add_2,
          "town":this.formData.town,
          "email":this.formData.email,
          "postcode":this.formData.postcode,
          "county":this.formData.county,
          "total": this.productsOrderTotal,
        };
        localStorage.setItem('checkoutData', JSON.stringify(checkoutData));
        this.showVenmoButton = true;

        return;

      } else {

      this.formData['products'] = this.products

      //localStorage.setItem('formData', JSON.stringify(this.formData));

      if(this.formData.aim && this.formData.aim.card) {
        this.formData.aim.card = this.formData.aim.card.replace(' ', '');
      }
      const submitdata = { ...this.formData, failed: this.failed }


      localStorage.removeItem("items")

      this.processing = true;

      axios.post('/api/checkout', submitdata).then(response => {

        if (this.formData.paymentType == 2) {
          if (response.data.error)
            this.paymentCreated = response.data;
        } else {
          setTimeout(() => {
            window.location.href = response.data.url
          }, 100)
          this.paymentCreated = response.data;
        }

        this.processing = false;

      })
          .catch(responseErrors => {
            this.failed = true

            if (responseErrors.response) {
              if (responseErrors.response.status == 301) {
                return location.href = responseErrors.response.data.redirect
              } else if (responseErrors.response.status == 500) {
                let avs = ('avs' in responseErrors.response.data) ? responseErrors.response.data.avs : ' ';
                let cvv = ('cvv' in responseErrors.response.data) ? responseErrors.response.data.cvv : ' ';
                let msgHtml = 'Purchase failed.<br>Try another card.';
                if (responseErrors.response.data.msg == 'A duplicate transaction has been submitted.') {
                  //window.alert('Same Error. Try again with different information');
                  msgHtml = 'Same Error.<br>Try again with different information.';
                } else if (responseErrors.response.data.msg == 'The credit card has expired.') {
                  //window.alert('Same Error. Try again with different information');
                  msgHtml = 'The credit card has expired.';
                } else if (responseErrors.response.data.msg == 'Credit card expiration date is invalid.') {
                  //window.alert('Same Error. Try again with different information');
                  msgHtml = 'The card expiration date entered does not match the debit/credit card provided.';
                } else if (['E'].includes(avs)) {
                  //window.alert('AVS data provided is invalid or AVS is not allowed for the card type that was used.');
                  msgHtml = 'AVS data provided is invalid or AVS is not allowed for the card type that was used.';
                } else if (['R'].includes(avs)) {
                  //window.alert('The AVS system was unavailable at the time of processing.')
                  msgHtml = 'The AVS system was unavailable at the time of processing.';

                } else if (['G'].includes(avs)) {
                  //window.alert('The card issuing bank is of non-U.S. origin and does not support AVS.')
                  msgHtml = 'The card issuing bank is of non-U.S. origin and does not support AVS.'

                } else if (['U'].includes(avs)) {
                  //window.alert('The address information for the cardholder is unavailable.')
                  msgHtml = 'The address information for the cardholder is unavailable.'

                } else if (['S'].includes(avs)) {
                  //window.alert('The U.S. card issuing bank does not support AVS.')
                  msgHtml = 'The U.S. card issuing bank does not support AVS.'

                } else if (['N'].includes(avs)) {
                  //window.alert('Address: No Match. ZIP Code: No Match.')
                  msgHtml = 'The billing address entered does not match the debit/credit card provided.<br>The zip code entered does not match the debit/credit card provided.'

                } else if (['A'].includes(avs)) {
                  //window.alert('Address: Match. ZIP Code: No Match.')
                  msgHtml = 'The zip code entered does not match the debit/credit card provided.'

                } else if (['Z'].includes(avs)) {
                  //window.alert('Address: No Match. ZIP Code: Match.')
                  msgHtml = 'The billing address entered does not match the debit/credit card provided.'

                } else if (['W'].includes(avs)) {
                  //window.alert('Address: No Match. ZIP Code: Matched 9 digits.')
                  msgHtml = 'The billing address entered does not match the debit/credit card provided.'

                } else if (['X'].includes(avs)) {
                  //window.alert('Address: Match. ZIP Code: Matched 9 digits.')
                  msgHtml = 'Purchase failed.<br>Try another card.'

                } else if (responseErrors.response.data.msg == 'The credit card number is invalid.') {
                  //window.alert('The credit card number is invalid. Try again with different card.');
                  msgHtml = 'The credit card number is invalid.<br>Try again with different card.'

                } else if ([' ', 'P'].includes(avs)) {
                  //window.alert('Purchase failed. Try another card.');
                  msgHtml = 'Purchase failed.<br>Try another card.'

                } else if (cvv != ' ') {

                  if( ['N', 'P', 'S', 'U'].includes(cvv) ) {
                    //window.alert('The credit card number is invalid. Try again with different card.');
                    msgHtml = 'The card security code (CVV) entered does not match the debit/credit card provided.'
                  }

                } else {
                  //window.alert('Purchase failed. Try another card.');
                  msgHtml = 'Purchase failed.<br>Try another card.'
                }

                this.$fire({
                  title: "Error",
                  html: msgHtml,
                  type: "error",
                  timer: 10000,
                });
              }
            }

            this.processing = false;

          })





      }



    },
    mappingModelToErrors(key) {
      let mapping = {
        first_name: 'firstName',
        last_name: 'lastName',
        'delInf.first_name': 'delfirstName',
        'delInf.last_name': 'dellastName',
        'delInf.add_1': 'deladd_1',
        'delInf.town': 'deltown',
        'delInf.postcode': 'delpostcode',
        'aim.card': 'cardNumber',
        'aim.month': 'expirationMonth',
        'aim.year': 'expirationYear',
      }
      return mapping[key] || key;
    },
    cardValidation() {
      if (this.formData.aim.card.length >= 1) {
        var cardno1 = /^(?:3[47][0-9]{13})$/;
        var cardno2 = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
        var cardno3 = /^(?:5[1-5][0-9]{14})$/;
        var cardno4 = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
        if (this.formData.aim.card.match(cardno1) || this.formData.aim.card.match(cardno2) || this.formData.aim.card.match(cardno3) || this.formData.aim.card.match(cardno4)) {
          $('#cardNumber').removeClass('error');
          return true;
        } else {
          $('#cardNumber').addClass('error');
          return false;
        }
      }
    },
    validateFieldOnFocus(e) {
      let validType = "checkEmpty"
      switch (e.target.id) {
        case 'pass':
          validType = "checkMatches"
          break;
      }
      return this[validType](e)
    },
    checkEmpty(e) {
      if (!e.target.value) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },
    checkMatches(e) {
      let neededField = e.target.getAttribute('data-match')
      if (!e.target.value || e.target.value !== this.formData[neededField]) {
        this.$set(this.invalidFields, e.target.id, true)
      } else {
        this.$set(this.invalidFields, e.target.id, undefined)
      }
    },
    updateProduct(e, product) {
      this.products.forEach((item, key) => {
        if (item.id == product.id) {
          item.quantity = e.target.value
          if (!item.quantity || item.quantity === "0") {
            this.products.splice(key, 1)
            this.cartItems.forEach((cartItem, k) => {
              if (cartItem.id == product.id) {
                this.cartItems.splice(k, 1)
              }
            })
            // this.$delete(this.product, key)
          } else {
            this.$set(this.products, key, item)
          }
        }
      })
    },
    clearCart() {
      this.cartItems = null;
      window.location.replace("/");
    },
    clearPaymentErrors() {
      if (this.formData.paymentType == 1) {
        for (let key in this.formData.aim) {
          this.$set(this.invalidFields, this.mappingModelToErrors('aim.' + key), undefined)
        }
        this.notRequiredInputs.push('aim|paymentType:Authorize_AIM')
      } else {
        this.notRequiredInputs.pop()
      }
    },
    checkMobileAndTablet() {

    },
    acceptNumber() {
      var x = this.formData.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.formData.phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
    }
  }
}
</script>
<style scoped>
.tdcartTitle2 img {
  width: 90px;
}
@media screen and (max-width: 970px) {
  .ship_frm_wrap {
    padding: 0 15px;
    background-image: none;
  }
  .ship_block {
    width: 100%;
  }
  .table-cart {
    width: 100%;
  }
  .tdcartTitle2 img {
    width: 70px;
  }
  .product-header {
    display: none !important;
  }
  .shiping_note {
    float: none;
  }
}
@media screen and (min-width: 971px) {
  .onlyMobile {
    display: none !important;
  }
}
@media screen and (max-width: 970px) {
  .onlyDesktop {
    display: none;
  }
}


.processing-message {
  text-align: center;
  margin-top: -1.5rem;
}

.processing-spinner {
  color: #2260dd;
  font-size: 4px;
  margin: 20px auto 48px;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}

</style>
